import { __awaiter, __generator } from "tslib";
import { reloadAppDefinitions } from './loadAppDefinitions';
import { searchAppDefinitions, setupM365AppsConfigService } from './utils';
export var findAppDefinitionById = function (appId) { return __awaiter(void 0, void 0, void 0, function () {
    var appDefinition;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!appId) {
                    return [2 /*return*/, undefined];
                }
                return [4 /*yield*/, setupM365AppsConfigService()];
            case 1:
                _a.sent();
                appDefinition = searchAppDefinitions(appId);
                if (!!appDefinition) return [3 /*break*/, 3];
                return [4 /*yield*/, reloadAppDefinitions()];
            case 2:
                _a.sent();
                appDefinition = searchAppDefinitions(appId);
                _a.label = 3;
            case 3: return [2 /*return*/, appDefinition];
        }
    });
}); };
//# sourceMappingURL=findAppDefinitionById.js.map